import React from "react";
import AddCategory from "./AddCategory/AddCategory";
import CategoryTable from "./CategoryTable/CategoryTable";

const Category = () => {
  return (
    <div className="lg:mr-8 mt-12">
      <CategoryTable />
      <br />
      <AddCategory />
      
    </div>
  );
};

export default Category;
